import React from 'react';

export default function HomeCrewBanner({
  show,
  crewsAtRisk = [],
  crewRiskBannerLabel = '',
  onVoteNow,
  homeCrewCount = 0,
  onCreateCrew,
  onOpenMyCrews,
  onViewCrewTrials,
  onOpenCrewArena,
}) {
  const visibleCrewNames = crewsAtRisk.map((crew) => crew?.crew_name).filter(Boolean).slice(0, 3);

  if (homeCrewCount <= 0) {
    return (
      <section className="rounded-3xl border border-slate-800/70 bg-gradient-to-b from-slate-900/65 to-slate-950/55 p-4 sm:p-5">
        <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-cyan-200/70">Your People</div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="text-lg font-extrabold text-slate-50">Get your people into the argument.</div>
            <div className="mt-1 text-sm text-slate-400">Crews turn random voting into side-taking, receipts, and people dragging you back in.</div>
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={onCreateCrew}
              className="rounded-lg bg-purple-600 hover:bg-purple-500 px-3 py-2 text-xs font-bold text-white"
            >
              Create Crew
            </button>
            <button
              onClick={onOpenMyCrews}
              className="rounded-lg bg-slate-700 hover:bg-slate-600 px-3 py-2 text-xs font-bold text-slate-100"
            >
              Browse Crews
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="rounded-3xl border border-cyan-400/25 bg-gradient-to-b from-cyan-950/18 to-slate-950/55 p-4 sm:p-5">
      <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-cyan-200/70">Your People</div>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="text-lg font-extrabold text-slate-50">
            {show ? 'Your crews still need your side.' : 'Your crews already picked sides.'}
          </div>
          <div className="mt-1 text-sm text-slate-300">
            {show
              ? (crewRiskBannerLabel || `${crewsAtRisk.length} crew calls are still movable.`)
              : `Across ${homeCrewCount === 1 ? '1 crew' : `${homeCrewCount} crews`}, your people already have verdicts hardening around a side.`}
          </div>
          {show && visibleCrewNames.length > 0 ? (
            <div className="mt-2 flex flex-wrap gap-2">
              {visibleCrewNames.map((name) => (
                <span
                  key={name}
                  className="rounded-full border border-cyan-400/25 bg-cyan-500/10 px-2.5 py-1 text-[11px] font-semibold text-cyan-100"
                >
                  {name}
                </span>
              ))}
            </div>
          ) : null}
          <div className="mt-2 text-xs text-slate-400">
            {show
              ? 'Your vote can still swing where your crew lands before the verdict hardens.'
              : 'Go see whether your side is winning, split, or already getting dragged.'}
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={show ? onVoteNow : onViewCrewTrials}
            className="shrink-0 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white px-3 py-2 text-xs font-bold"
          >
            {show ? 'Back Your Crew' : 'See Crew Outcomes'}
          </button>
          <button
            onClick={onOpenCrewArena || onOpenMyCrews}
            className="shrink-0 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-100 px-3 py-2 text-xs font-bold"
          >
            {show ? 'Open Crew Arena' : 'Crew Arena'}
          </button>
        </div>
      </div>
    </section>
  );
}
